import { RegistrationType } from '../types/registration.type';
import { environment } from '../../environments/environment';

export const REGISTRATION_TYPES = {
  ENTHUSIAST: 'enthusiast',
  ORGANIZER: 'organizer',
  ADMIN: 'admin',
} as const;

export const ROLE_ID_BY_REGISTRATION_TYPE: Record<RegistrationType, number> = {
  [REGISTRATION_TYPES.ENTHUSIAST]: 1,
  [REGISTRATION_TYPES.ORGANIZER]: 2,
  [REGISTRATION_TYPES.ADMIN]: 4,
};

const COUNTRY_ID_BY_COUNTY_CODE: Record<string, number> = {
  LV: 1,
  EE: 2,
  LT: 3,
  FI: 4,
};

export const ASPECT_RATIO = {
  LOGO: 1,
  COVER_IMG: 16 / 9,
} as const;

export const FILE_TYPE_ID = {
  LOGO: 1,
  DOCUMENT: 2,
} as const;

export const ICONS = {
  CLOCK: 'clock',
  CLOSE: 'close',
  EDIT: 'edit',
  EDIT_16: 'edit-16',
  EDIT_V2_16: 'edit-v2-16',
  HOME: 'home',
  LOGOUT_16: 'logout-16',
  MARKER_PIN: 'marker-pin',
  PLUS_16: 'plus-16',
  SEARCH: 'search',
  SEARCH_24: 'search-24',
  SETTINGS_16: 'settings-16',
  TRASH: 'trash',
  UPLOAD_CLOUD: 'upload-cloud',
  USER_16: 'user-16',
  CALENDAR: 'calendar',
  CALENDAR_HEART_02_16: 'calendar-heart-02-16',
  ALERT_CIRCLE: 'alert-circle-16',
  X_CIRCLE: 'x-circle-16',
  MENU_01_24: 'menu-01-24',
  HELP_CIRCLE_16: 'help-circle-16',
} as const;

export const SITE_LANGUAGE = {
  LV: 'lv',
  EN: 'en',
} as const;

export const BUTTON_STYLES = {
  DANGER: 'danger',
  DANGER_OUTLINED: 'danger-outlined',
  ACTION: 'action',
  NEUTRAL: 'neutral',
  BLACK: 'black',
  WHITE: 'white',
  WHITE_OUTLINED: 'white-outlined',
  SUCCESS: 'success',
  UNSTYLED: 'unstyled',
  NONE: null,
} as const;

export const COLOR_STYLES = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  SUCCESS: 'success',
  INFO: 'info',
  WARNING: 'warning',
  DANGER: 'danger',
  LIGHT: 'light',
  DARK: 'dark',
  GREY: 'grey',
} as const;

export const TIME_SEPARATOR = ':' as const;
export const SHOW_TRANSLATION_ID = 'show_translation_id' as const;
export const LOCALHOST_URL = 'localhost' as const;
export const DEV_URL = 'dev.spocaboo.com' as const;
export const BREAKPOINT_MD = 768;
export const DEFAULT_BANNER_IMAGE =
  '/assets/images/event_background_default.png';
export const DEFAULT_EVENT_LOGO = 'assets/images/event_logo_default.svg';

export const PASSWORD_STRENGTH_KEY = 'passwordStrength' as const;
export const PASSWORD_STRENGTH_SCORE = {
  ERROR: 1,
  WARNING: 2,
  SUCCESS: 3,
} as const;

export const ERROR_EMAIL_NOT_VERIFIED = 'error_email_not_verified';
export const ERROR_WRONG_EMAIL_OR_PASSWORD = 'error_wrong_email_or_password';

export const CONSTANTS = {
  DATE_DISPLAY_FORMAT: 'dd/MM/yyyy',
  DATE_SQL_FORMAT: 'yyyy/MM/dd',
  DATE_TIME_SQL_FORMAT: 'yyyy/MM/dd HH:mm:ss',
  DEFAULT_CURRENCY: 'EUR',
  GOOGLE_API_KEY: 'AIzaSyB4BZJgeWIQaF6aVIKYj_d1-o0YPlaP3ow',
  SENTRY_DSN:
    'https://63490a356f92090cdf5d6b6e5e747e69@o4508641937784832.ingest.de.sentry.io/4508641959739472',
  BASE_API: `${environment.baseBE}`,
  BASE_PAYMENT_API: `${environment.basePaymentBE}`,
  COUNTRY: `LV`,
  PAYMENT_BRAND_ID: '702314b8-dd86-41fa-9a22-510fdd71fa92',
  PAYMENT_SECRET_KEY:
    'IB-bzOdJLgJjbsaA34Qpxkg1TTIrW-iDuni6JuzbP--KgtsREHzvIvLLTH8E5T0CZcSbYM3qNmfeogpWW_RZaA==',
  REGISTRATION_TYPES: {
    [REGISTRATION_TYPES.ENTHUSIAST]: 'Athlete',
    [REGISTRATION_TYPES.ORGANIZER]: 'Event Organizer',
  },
  REGEX: {
    EMAIL: /^\w+([+.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/,
  },
  GENDER_OPTIONS: [
    {
      id: 'm',
      itemName: 'Male',
    },
    {
      id: 'f',
      itemName: 'Female',
    },
  ],
  ROLE_ID_BY_REGISTRATION_TYPE,
  COUNTRY_ID_BY_COUNTY_CODE,
  RECAPTCHA: {
    SITE_KEY: '6LfBcjUqAAAAAMUszwxv3Hy2JSif4CRNzPPTCIVU',
  },
};

export const CONTACT_US_SUBJECTS = [
  {
    id: 'Feedback / feature request',
    itemName: 'Feedback / feature request',
  },
  {
    id: 'Suggest an event',
    itemName: 'Suggest an event',
  },
  {
    id: 'Event organizer account request',
    itemName: 'Event organizer account request',
  },
  {
    id: 'Other',
    itemName: 'Other',
  },
];
